
<template>
  <v-card>

<!-- Carga de archivo  -->
  <v-container fluid>
    <v-card>
  <form ref="form"
  lazy-validation>
      <v-row align="end"
      style="height: 100px">
          <v-col  cols="12" sm="6" md="3">
          <v-container>
              <template>
              <v-file-input v-model="editedItem.files"
                  accept=".xlsx"
                  label="Archivo excel"
                  placeholder="Seleccione su archivo"
                  name="file"  
                  id="file"
                  @click="$event.target.value=[]"
              ></v-file-input>
              </template>
          </v-container>
          </v-col>
      </v-row>
      <v-row class="px-4">
      <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="editedItem.Motive" label="Motivo" required></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="editedItem.Commentary" label="Comentario" required></v-text-field>
      </v-col>
      <v-col align-self="center" cols="12" sm="6" md="3">
        <v-btn :disabled="editedItem.files.length == 0 || editedItem.Motive == ''  || editedItem.Commentary == ''" color="primary" @click="carga">Cargar</v-btn>
      </v-col>
      <v-col align-self="center" cols="12" sm="6" md="3">
        <v-btn color="primary" @click="submit">Buscar Todos</v-btn>
      </v-col>
      </v-row>
    </form>

    <v-spacer></v-spacer>
    </v-card>
    </v-container>
<!-- Propuestas Grid  -->
    <v-container fluid>
    <v-card>
        <v-card-title>
        <v-icon x-large>mdi-clipboard-list-outline</v-icon>Propuestas <span>({{ this.ApiUserSupplier.length > 0 ? this.ApiUserSupplier[0] : 'Todos los proveedores' }})</span>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtro"
            single-line
            hide-details
        ></v-text-field>
        </v-card-title>
        <v-data-table
        :headers="headers"
        :items="mvm"
        :search="search"
        sort-by="calories"
        class="elevation-1"
        style="height: 150px; overflow-y: auto;"
        >
        <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="view_detail(item)"
                >
                mdi-eye
                </v-icon>
            </template>
            <span>Ver Detalle</span>
            </v-tooltip>
        </template>
        </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>

<!-- Pedidos Grid  -->
    <v-container fluid>
      <v-card>
       <v-card-title>
        Pedidos
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search2"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <template>
        <v-row  v-if="isApprover">
          <v-col class="text-right">
            <!-- <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="checkAllRadios('A')">
              <v-icon color="success">mdi-check-circle</v-icon> Aprobar Todos
            </v-btn>
            <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="checkAllRadios('C')">
              <v-icon color="error">mdi-delete-circle</v-icon> Eliminar Todos
            </v-btn> -->
            <!-- <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="openDialog(mvm_detail)"> 
              <v-icon color="info">mdi-pencil-circle</v-icon> Editar Todos 
            </v-btn> -->
          </v-col>
        </v-row>
        
      </template>

      <v-data-table
      :headers="headers2"
      :items="mvm_detail"
      :search="search2"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="view_detail_delivery(item)"
              >
              mdi-eye
              </v-icon>
          </template>
          <span>Ver Detalle</span>
          </v-tooltip>
      </template>

      <!-- Botón Aprobar -->
      <template v-slot:item.Aprobar="{ item }">
        <td class="text-xs-right">
          <v-btn 
            color="success" 
            small 
            :disabled="item.SUM_Delivery_Qty >=  item.Order_Qty && item.SUM_status == 0" 
            @click="openDialogApproveItem(item)"
          >
            Aprobar
          </v-btn>
        </td>
      </template>
      <!-- Botón Editar -->
      <template v-slot:item.Editar="{ item }">
        <td class="text-xs-right">
          <v-btn 
          color="primary" 
          small 
          :disabled="item.SUM_Delivery_Qty >=  item.Order_Qty && item.SUM_status == 0" 
          @click="openDialog(item)"
            >
          Editar
          </v-btn>
        </td>
      </template>
    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>

<!-- Detalle de Entregas Grid -->
    <v-container fluid>
      <v-card>
       <v-card-title>
         Detalle de Entregas
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search2"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
      :headers="headers3"
      :items="mvm_detail_entrega"
      :search="search3"
      sort-by="calories"
      class="elevation-1"
    >



       <!-- Botón Eliminar -->
       <template v-slot:item.Eliminar="{ item }">
        <td class="text-xs-right">
          <v-btn 
            color="error" 
            small 
            :disabled="item.Delivery_Status == 'Enviado'" 
            @click="openDialogDeleteItem(item)"
          >
            Eliminar
          </v-btn>
        </td>
      </template>
      
      <!-- Botón Editar -->
      <template v-slot:item.Editar="{ item }">
        <td class="text-xs-right">
          <v-btn 
          color="primary" 
          small 
          :disabled="item.Delivery_Status == 'Enviado'" 
          @click="openDialogEditDelivery(item)"
            >
          Editar
          </v-btn>
        </td>
      </template>
    </v-data-table>
    </v-card>
    </v-container>

    <v-spacer></v-spacer>

<!-- Pop up Editar pedido -->
    <v-dialog v-model="dialog" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span class="text-h6">Editar Pedido</span>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers_edit"
            :items="items_edit"
            class="elevation-1"
            dense
            hide-default-footer
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td style="vertical-align: middle;">{{ item.folio_id }}</td>
                  <td style="vertical-align: middle;">{{ item.ean }}</td>
                  <td style="vertical-align: middle;">{{ item.punto }}</td>
                  <td style="vertical-align: middle;">{{ item.producto }}</td>
                  <td style="vertical-align: middle;">{{ item.pedido }}</td>

                  <!-- Campo: Cantidad a Entregar -->
                  <td style="vertical-align: middle;">
                    <v-text-field
                      v-model.number="item.cantEntregar"
                      type="number"
                      min="0"
                      dense
                      outlined
                      hide-details
                      class="pa-0"
                    ></v-text-field>
                  </td>

                  <!-- Campo: Fecha de Entrega -->
                  <td style="vertical-align: middle;">
                    <v-menu
                      v-model="item.fechaEntregaMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.fechaEntrega"
                          dense
                          outlined
                          hide-details
                          readonly
                          class="pa-0"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.fechaEntrega"
                        :min="minFechaEntrega"
                        no-title
                        @input="item.fechaEntregaMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </td>

                  <!-- Campo: Hora de Entrega -->
                  <td style="vertical-align: middle;">
                    <v-text-field
                      v-model="item.horaEntrega"
                      type="text"
                      dense
                      outlined
                      hide-details
                      class="pa-0"
                      placeholder="HH:MM"
                    ></v-text-field>
                  </td>

                  <!-- Mensaje de error -->
                  <td style="vertical-align: middle;">{{ item.errorMsg }}</td>
                </tr>
              </tbody>

            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" medium @click="acceptChanges" :disabled="accept_changes">Aceptar</v-btn>
          <v-btn color="error" medium @click="closeDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
<!-- Pop up Editar entrega -->
<v-dialog v-model="dialog_edit" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span class="text-h6">Editar Entrega</span>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers_edit"
            :items="items_edit"
            class="elevation-1"
            dense
            hide-default-footer
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td style="vertical-align: middle;">{{ item.folio_id }}</td>
                  <td style="vertical-align: middle;">{{ item.ean }}</td>
                  <td style="vertical-align: middle;">{{ item.punto }}</td>
                  <td style="vertical-align: middle;">{{ item.producto }}</td>
                  <td style="vertical-align: middle;">{{ item.pedido }}</td>

                  <!-- Campo: Cantidad a Entregar -->
                  <td style="vertical-align: middle;">
                    <v-text-field
                      v-model.number="item.cantEntregar"
                      type="number"
                      min="0"
                      dense
                      outlined
                      hide-details
                      class="pa-0"
                    ></v-text-field>
                  </td>

                  <!-- Campo: Fecha de Entrega -->
                  <td style="vertical-align: middle;">
                    <v-menu
                      v-model="item.fechaEntregaMenuDelivery"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.fechaEntregaDelivery"
                          dense
                          outlined
                          hide-details
                          readonly
                          class="pa-0"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.fechaEntregaDelivery"
                        :min="minFechaEntregaDelivery"
                        no-title
                        @input="item.fechaEntregaMenuDelivery = false"
                      ></v-date-picker>
                    </v-menu>
                  </td>

                  <!-- Campo: Hora de Entrega -->
                  <td style="vertical-align: middle;">
                    <v-text-field
                      v-model="item.horaEntrega"
                      type="text"
                      dense
                      outlined
                      hide-details
                      class="pa-0"
                      placeholder="HH:MM"
                    ></v-text-field>
                  </td>

                  <!-- Mensaje de error -->
                  <td style="vertical-align: middle;">{{ item.errorMsg }}</td>
                </tr>
              </tbody>

            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" medium @click="acceptChangesDelivery" :disabled="accept_changes_delivery">Aceptar</v-btn>
          <v-btn color="error" medium @click="closeDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
<!-- Pop up borrar -->
    <v-dialog v-model="dialog_delete" max-width="350">
      <v-card class="px-2 py-2">
        <v-card-title class="headline mb-3"> ¿Desea borrar pedido?</v-card-title>
        <v-card-actions>
        <v-spacer></v-spacer>
            <v-btn color="primary" @click="close">Volver</v-btn>
            <v-btn color="error" @click="deleteRegistry" >Borrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

          
<!-- Pop up Aprobar -->
    <v-dialog v-model="dialog_approve" max-width="350">
      <v-card>
        <v-card-title class="headline"> ¿Desea aprobar pedido?</v-card-title>
        <v-spacer></v-spacer>
        <div class="text-center">
            <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
            {{this.msj_proceso}}
          </div>
        <v-card-actions>
        <v-spacer></v-spacer>
            <v-btn color="primary" @click="close">Volver</v-btn>
            <v-btn color="success" @click="approveRegistry" :disabled="approveBtnDisabled">Aprobar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-spacer></v-spacer>
<!-- Aplicar cambios y Descargar Detalle -->
  <template>
    <div class="text-center d-flex justify-space-around">
      <!-- <v-btn v-if="isApprover" type="button" :disabled="isApplyChangesBtnDisabled" color="primary" @click="submitChanges" class="mx-2 mb-2">Aplicar Cambios</v-btn> -->
      <v-btn type="button" color="primary" @click="onexport" class="mx-4">Descargar Detalle</v-btn>
    </div>
  </template>
<!-- Pop up  -->
    <v-dialog v-model="dialog_new" max-width="900px">
    <v-stepper v-model="e1" vertical>
           <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
              <small>{{this.step_txt2}}</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>  
      </v-stepper>
    </v-dialog>
<!-- Pop up Aplicar cambios  -->
    <v-dialog v-model="dialog_new_apply" max-width="900px" persistent>
    <div>
      <v-stepper :model-value="e1">
        <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
        <v-stepper-header>
          <v-stepper-step
            step="1"
            :complete="e1 > 1"
          >Guardando cambios</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step 
          step="2"
          :complete="e1 > 2"
          >Aplicando Cambios
          <small>Modificando datos en tablas</small>
      </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step 
          step="3"
          :complete="e1 > 3"
          > Enviando mails</v-stepper-step>
        </v-stepper-header>
        <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
      </v-stepper>
    </div>
    </v-dialog>

<!-- Pop up Aprobar  -->
    <v-dialog v-model="dialog_apply_approve" max-width="900px" persistent>
    <div>
      <v-stepper :model-value="e1">
        <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
        <v-stepper-header>
          <v-stepper-step
            step="1"
            :complete="e1 > 1"
          >Guardando cambios</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step 
          step="2"
          :complete="e1 > 2"
          >Aplicando Cambios
          <small>Enviando Mails</small>
      </v-stepper-step>

  
        </v-stepper-header>
        <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
      </v-stepper>
    </div>
    </v-dialog>

<!-- Pop up Carga  -->
    <v-dialog v-model="dialog_load" max-width="400" persistent>
      <v-card color="blue-grey darken-3" dark>
        <div v-if="!invalidHeaders">
          <v-card-title class="headline">Cantidad de Filas Procesadas</v-card-title>
          <v-card-text class="text-h6" style="padding-bottom:0; padding-top:0;">Correctas: {{ rowsOk }}</v-card-text>
          <v-card-text class="text-h6" style="padding-bottom:0; padding-top:0;">Formato incorrecto: {{ rowsBadFormat }}</v-card-text>
          <div v-if="rowErrors && rowErrors.length > 0">
            <v-list style="max-height: 200px; overflow-y: auto;" class="blue-grey darken-3">
              <v-list-item v-for="error in rowErrors" :key="error.line">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal; color: red;">
                    Línea {{ error.line }}: {{ error.errors }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <v-card-text class="text-h6" style="padding-bottom:4; padding-top:0;">Omitidas: {{ rowsOmmited }}</v-card-text>
          <div v-if="noRows">
            <v-card-subtitle>No hay filas para procesar</v-card-subtitle>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn color="primary" @click="close_retry">Cerrar</v-btn>
                <!-- <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn> -->
            </v-card-actions>
          </div>
          <div v-if="!noRows">
            <div style="display:flex; justify-content:center" v-if="!processComplete">
              <v-progress-circular model-value="20" indeterminate class="mx-2"></v-progress-circular><span>Aguarde mientras se procesa la solicitud</span>
            </div>
            <div style="display: flex; justify-content: center; max-height: 200px; overflow-y: auto;" v-else-if="processComplete">
              <v-card-text :style="{ color: textColorMsj }" class="text-h6">{{ msjError }}</v-card-text>
            </div>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog_load=false" :disabled="!processComplete">Cerrar</v-btn>
            </v-card-actions>
          </div>
        </div>
        <div v-else-if="invalidHeaders">
          <v-card-subtitle>Las cabeceras del archivo no concuerdan con los esperados.</v-card-subtitle>
          <v-card-actions>
          <v-spacer></v-spacer>
              <!-- <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn> -->
              <v-btn color="primary" @click="close_retry">Cerrar</v-btn>
          </v-card-actions>
        </div>
        
      </v-card>
    </v-dialog>

    
    <v-overlay :value="progressBarInitialize" :opacity="0.85" z-index="9999">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <div class="mt-4">Inicializando variables</div>
      </div>
    </v-overlay>

    </v-card>
  </template>
  
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";
    //import JsonExcel from "vue-json-excel";
    import XLSX from 'xlsx';
     
    //Vue.component("downloadExcel", JsonExcel);
    
    export default {
      data: () => ({
        items_edit:'',
        rowsOmmited: 0,
        rowsBadFormat: 0,
        rowErrors:0,
        rowsOk: 0,
        noRows: false,
        processComplete: false,
        invalidHeaders: false,
        textColorMsj: "white",
        msjError: "",
        search: '',
        search2: '',
        search3: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialog_edit: false,
        dialog_pass: false,
        dialog_new: false,
        dialog_new_apply: false,
        dialog_approve: false,
        dialog_apply_approve: false,
        dialog_detail: false,
        dialog_load: false,
        dialog_delete: false,
        valid: true,
        menu: false,
        menu2: false,
        e1: 0,
        btnap:true,
        btn: false,
        msj_proceso:'',
        progressBar1: false,
        progressBar: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        RequestProposal_id:'',
        step_txt1:'',
        step_txt2:'',
        TurningStorageArea_id:'',
        TurningStorageArea_Desc:'',
        OpPoint_id: '',
        Supplier_Description:'',
        VendorPurchaseOrder_Num:'',
        Section_id:'',
        LastOpRepUser_id: '',
        RepEvent_Dttm: '',
        ApiUser_GivenName:'',
        status:'',
        CDay_id:'',
        CHour_Description:'',
        id_process:'',
        isApprover: false,
        ApiUserSupplier: [],
        ApiUserType: '',
        currentProposalId: '',
        accept_changes: false,
        accept_changes_delivery: false,
        cantEnviada: 0,
        enviarPedidoCompleto: false,
        approveBtnDisabled: false,
        progressBarInitialize: true,
        headers: [
          { text: 'Actions', value: 'action', sortable: false },
          { text: 'Prov', value: 'Supplier_id' },  
          { text: 'R Social', value: 'Supplier_Description' },
          { text: 'Motivo', value: 'InternalObservation' },
          { text: 'Comentario', value: 'InternalNote_Txt' },
          { text: 'Status', value: 'Status_id' },
          { text: 'Fecha creacion', value: 'PreOrderPurchase_Dt' },
          { text: 'Hora Creacion', value: 'PreOrderPurchase_Tm'}
        ],
        headers2:[
          { text: 'Actions', value: 'action', sortable: false },
          { text: 'Folio', value: 'Folio_id' },  
          { text: 'Punto', value: 'OpPoint_id' },
          { text: 'Producto', value: 'Product_Description' },
          { text: 'Ean', value: 'ProductBarCode_id' },
          { text: 'Cant. Pedido', value: 'Order_Qty' },
          { text: 'Unidad PCB', value: 'PCB_Qty' },
          { text: 'Fecha de Entrega', value: 'PreferredDelivery_Dt' },
          { text: 'Hora de Entrega', value: 'Delivery_Tm' },
          { text: 'Error', value: 'ReplicationError_Cd'},
          { text: 'Error Desc', value: 'ReplicationError_desc'}
        ],
        headers3:[
          { text: 'Folio', value: 'Folio_id' },  
          { text: 'Punto', value: 'OpPoint_id' },
          { text: 'Producto', value: 'Product_Description' },
          { text: 'Ean', value: 'ProductBarCode_id' },
          { text: 'Cant. a Entregar', value: 'Delivery_Qty' },
          { text: 'Fecha Edicion', value: 'Delivery_Edit' },
          { text: 'Estado Entrega', value: 'Delivery_Status' }
        ],
        headers_edit: [
          { text: "Folio", value: "folio_id" },
          { text: "EAN", value: "ean" },
          { text: "Punto", value: "oppoint_id" },
          { text: "Producto", value: "producto" },
          { text: "Pedido", value: "pedido" },
          { text: "Cant. Entregar", value: "cantEntregar" },
          { text: "Fecha Entrega", value: "fechaEntrega" },
          { text: "Hora Entrega", value: "horaEntrega" },
          { text: "Error Msg", value: "errorMsg" },
        ],
        mvm: [],
        mvm_detail: [],
        mvm_detail_entrega: [],
  
        editedIndex: -1,
        editedItem: {
          fecha: new Date().toISOString().substr(0, 10),
          files: [],
          Motive: '',
          Commentary: ''
        },
        minFechaEntrega: '',
        minFechaEntregaDelivery: '',
        
        fechaRule: [
            v => !!v || 'Fecha es requerida'
        ],
        datoRule: [
            v => !!v || 'El dato es Requerido'
           
        ],
        
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      computed: {
        formTitle () {
          return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
        },
        isApplyChangesBtnDisabled(){
          let status = [];
          if(this.mvm_detail.length != 0){
            this.mvm_detail.map(detail => {
              status.push(detail.RequestProposalStatus_Cd)
            })
            if(status.includes("")){
              return true;
            }else{
              return false;
            }
          }else{
            return true
          }
        },
  
        isSelectAllBtnDisabled(){
          return this.mvm_detail.length != 0 ? false : true 
        }
      },
    
      watch: {
        dialog (val) {
          val || this.close()
        }
      },
    
      created () {
        this.initialize()
      },

      mounted() {
        const hoy = new Date();
        hoy.setDate(hoy.getDate() + 1); // mañana
        this.minFechaEntrega = hoy.toISOString().split('T')[0]; // yyyy-mm-dd
        this.minFechaEntregaDelivery = hoy.toISOString().split('T')[0]; // yyyy-mm-dd
      },
    
      methods: {
  
      async initialize () {
        this.progressBarInitialize = true

        const apiUser = sessionStorage.getItem('ApiUser_id')

        const getRoles = axios
          .post(this.api_tool_url + '/get_roleuser', { ApiUser_id: apiUser }, this.config)
          .then(response => {
            const roles = response.data.ResultRows
            if (roles.find(role => role.ApiRole_id == 'administrator' || role.ApiRole_id == 'preorder_approver')) {
              this.isApprover = true
              this.headers2.push({ text: '', value: 'Aprobar' })
              this.headers2.push({ text: '', value: 'Editar' })
              this.headers3.push({ text: '', value: 'Aprobar' })
              this.headers3.push({ text: '', value: 'Eliminar' })
              this.headers3.push({ text: '', value: 'Editar' })
            } else if (roles.find(role => role.ApiRole_id == 'externos' || role.ApiRole_id == 'internos')) {
              this.isApprover = true
              this.headers2.push({ text: '', value: 'Editar' })
              this.headers3.push({ text: '', value: 'Editar' })
            }
          })
          .catch(error => {
            alert(this.getErrorMsg(error))
          })

        const getSupplier = axios
          .post(this.api_tool_url + '/get_ApiUserSupplier', { ApiUser_id: apiUser }, this.config)
          .then(response => {
            response.data.ResultRows.forEach(info => {
              this.ApiUserSupplier.push(info.MotherSupplier_Desc)
              this.ApiUserSupplier.push(info.ApiUser_Supplier)
            })
          })
          .catch(error => {
            this.ApiUserSupplier = []
            alert(this.getErrorMsg(error))
          })

        const getType = axios
          .post(this.api_tool_url + '/get_ApiUserType', { ApiUser_id: apiUser }, this.config)
          .then(response => {
            this.ApiUserType = response.data.ResultRows
          })
          .catch(error => {
            this.ApiUserType = ''
            alert(this.getErrorMsg(error))
          })

        // Espera a que terminen las 3 llamadas (cada una ya maneja su propio error)
        await Promise.all([getRoles, getSupplier, getType])

        this.progressBarInitialize = false
        },

          // Helper para no romper si el error no trae response (ej: error de red)
        getErrorMsg (error) {
          return (error.response && error.response.data && error.response.data.message)
            || error.message
            || 'Error desconocido'
          },
  
        carga() {
          
          this.btn = true
          this.btnap=true
          this.noRows = false;
          this.invalidHeaders = false;
          this.processComplete = false;
          this.dialog_load = false;
          let filter = new FormData();
          this.mvm = []
          let file = this.editedItem.files;
          
          if (file) 
          {
            const reader = new FileReader();
            reader.onload = (e) => 
              {
                this.dialog_load = true;
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
  
                data = data.filter(subArr => subArr.length > 0);
  
                if (data.length <= 1) {
                    this.noRows = true;
                    this.overlay = false;
                    return;
                }
                
                let headers = data[0];
                /*
                const requiredHeaders = ['Punto_Operacional_Id', 'Orden_Compra_Num', 'Fecha_Turno', 'Hora_Turno', 'Tipo_Movimiento', 'Folio_Id', 'Fecha_Entrega', 'Fecha_Cierre', 'Hora_Entrega', 'Comentario1', 'Observacion_Interna', 'NotaInterna_Txt', 'Accion_Ind', 'Tipo_Orden_Compra_Id', 'Op_Plataforma_Num', 'Fecha_Expiracion_OP_Plataforma', 'Inmediato_Ind', 'EAN_Id', 'PCB_Cant', 'Pedido_Cant', 'CostoUsuario_Mnt', 'Validar_Turnado'];
  
                let validHeaders = requiredHeaders.every(header => headers.includes(header));
  
                if (!validHeaders) {
                    this.invalidHeaders = true;
                    this.overlay = false;
                    return;
                }
                */
                let cantOmitidos = 0;
                let cantFormatoError = 0;
                let cantOk = 0;
                let rowsComplete = [];
                let errors = [];
  
                let idxOppoint = headers.indexOf('Punto_Operacional_Id');
                let idxFechaTurno = headers.indexOf('Fecha_Entrega');
                let idxFechaCierre = headers.indexOf('Fecha_Cierre');
                let idxHoraTurno = headers.indexOf('Hora_Entrega');
                let idxFolioId = headers.indexOf('Folio_Id');
  
                let regExpLetras = /[a-zA-Z]/g;
                // let regExpFecha = /^\d{4}-\d{2}-\d{2}$/;
                // let regExpFechaAlt = /^\d{2}-\d{2}-\d{4}$/;
                const hoy = new Date();
                const hoyString = hoy.toISOString().split('T')[0];
                //console.log('hoy:', hoyString)
  
                data.forEach((row, index) => {
                    if (index === 0) return; // Saltar cabecera
  
                    const opPointValue = row[idxOppoint];
                    const fechaTurnoValue = row[idxFechaTurno];
                    const fechaCierreValue = row[idxFechaCierre];
                    const horaTurnoValue = row[idxHoraTurno];
                    const folioId = row[idxFolioId];
                    
  
                    let errorMessages = [];
                    //console.log('opPointValue:', opPointValue)
                    //console.log('fechaTurnoValue:',fechaTurnoValue)
                    //console.log('horaTurnoValue:',horaTurnoValue)
                    //console.log('folioId:',folioId)
                    if (
                        opPointValue === undefined || opPointValue === null || opPointValue === '' ||
                        fechaTurnoValue === undefined || fechaTurnoValue === null || fechaTurnoValue === '' ||
                        folioId === undefined || folioId === null || folioId === '' ||
                        horaTurnoValue === undefined || horaTurnoValue === null || horaTurnoValue === ''
                    ) {
                        cantOmitidos += 1;
                    } else if (
                        regExpLetras.test(opPointValue.toString()) || 
                        regExpLetras.test(folioId.toString()) ||              
                        isNaN(Number(horaTurnoValue))     ||
                        fechaTurnoValue < hoyString  ||
                        fechaCierreValue < fechaTurnoValue             
                        //|| !regExpFecha.test(fechaTurnoValue.toString())
                    ) {
                        cantFormatoError += 1;
  
                        if (regExpLetras.test(opPointValue.toString())) {
                            errorMessages.push("Punto_Operacional_Id contiene letras.");
                        }
                        else if (regExpLetras.test(folioId.toString())) {
                            errorMessages.push("Folio_Id contiene letras.");
                        }
                        else if (isNaN(Number(horaTurnoValue))) {
                            errorMessages.push("Hora_Entrega no es numérico.");
                        }
                        // else if (!regExpFecha.test(fechaTurnoValue.toString())) {
                        //     errorMessages.push("Fecha_Entrega no cumple el formato.");
                        // }
                        else if(fechaTurnoValue < hoyString){
                            errorMessages.push("Fecha_Entrega debe ser mayor a la fecha actual.");
                        }
                        else if(fechaCierreValue < fechaTurnoValue){
                            errorMessages.push("Fecha_Cierre debe ser mayor a la Fecha_Entrega.");
                        }
                        else
                        {
                            errorMessages.push("Revisar.");
                        }
  
                        errors.push({
                            line: index + 1,
                            errors: errorMessages.join(" ")
                        });
                    } else {
                        cantOk += 1;
                        rowsComplete.push(row);
                    }
                });
  
                this.rowsOmmited = cantOmitidos;
                this.rowsBadFormat = cantFormatoError;
                this.rowsOk = cantOk;
                this.rowErrors = errors;
                
                filter.append('foo', 'bar');
                filter.append('file', document.getElementById('file').files[0]);
                filter.append('email', sessionStorage.getItem('ApiUser_EMail'));
                filter.append('user', sessionStorage.getItem('ApiUser_id'));
                filter.append('token',sessionStorage.getItem('access_token'))
                filter.append('motive', this.editedItem.Motive)
                filter.append('commentary', this.editedItem.Commentary)
                
                if (!errors.length){
                  axios.post(this.api_tool_url + '/PreOrder_fileUpload', filter, this.config)
                  .then(response => {
                          if(response.data.status == "OK"){
                            //console.log('Aqui en mvm')
                            this.mvm = response.data.ResultRows
                            this.id_process = response.data.PreOrderPurchase_id 
                            this.btnap=false
                            this.btn = false
                            this.active = false  
                            this.editedItem.files = []
                            this.msjError = 'Propuesta cargada correctamente.';
                            this.textColorMsj = this.msjError ? "white" : "";
                            this.processComplete = true;
                            this.overlay = false;
                            setTimeout(() => {
                              this.dialog_load = false;
                            }, 5000);
                          }else {
                              this.msjError = response.data.Msg + " -> " + JSON.stringify(response.data.ResultRows);
                              this.textColorMsj = this.msjError ? "red" : "";
                              this.processComplete = true;
                              //console.log(response.data.ResultRows)
                              this.mvm = [] 
                              this.btn = false
                              this.active = true
                              this.editedItem.files = []
                          }
                          this.btn = false  
                      })
                      .catch(error => {
                          this.btn = false
                          this.msjError = error.response.data;
                          this.textColorMsj = this.msjError ? "red" : "";
                          this.processComplete = true;
                          this.active = true
                          this.editedItem.files = []
                      })
                }else{
                  this.btn = false
                  this.msjError = "Corrija el archivo y vuelva a cargarlo.";
                  this.textColorMsj = this.msjError ? "red" : "";
                  this.processComplete = true;
                  this.active = true
                  this.editedItem.files = []
                }
                  this.editedItem = {
                  fecha: new Date().toISOString().substr(0, 10),
                  files: [],
                  Motive: '',
                  Commentary: ''
                  }
  
              };
              reader.readAsBinaryString(file);
          }
        },
        
    
        close () {
          this.dialog_new = false
          this.dialog_new_apply = false
          this.dialog_delete = false
          this.dialog_approve = false
          this.dialog_apply_approve = false
        },
        close2 () {
          this.dialog_detail= false
        },
        close_retry () {
          this.dialog_load= false
          this.editedItem.fecha= new Date().toISOString().substr(0, 10)
          this.editedItem.files = []
          this.editedItem.Commentary = ''
          this.editedItem.Motive = ''
        },
        submitChanges(){
          this.e1 = 1
          this.dialog_new_apply = true;
          this.progressBar = true
          this.msj_proceso = "Guardando modificaciones."
          //console.log('Aplicar cambios')
          //console.log(this.mvm_detail)
          let filter = null
          let filteredDetails = this.mvm_detail.filter(item => !item.isCheckboxDisabled)
          filter = {Details:filteredDetails , email: this.$store.state.ApiUser_EMail}
          axios.post(this.api_tool_url + '/save_proposalTurnLineUpdate',filter, this.config)
          .then(response => {
            if(response.data.ResultRows.length >= 1)
            {
              this.e1= 2
              this.msj_proceso = "Persistiendo cambios en tablas."
              let data={ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token'), ProposalTurnUpdate_id: this.currentProposalId}
  
              axios.post(this.api_tool_url + '/ApplyChanges_modif', data, this.config)
                  .then(response => {
                      if(response.data.ResultRows.length >= 1)
                      {
                        this.e1=3
                        this.msj_proceso = "Enviando mail a proveedor con los cambios."
  
                        axios.post(this.api_tool_url + '/send_proposalTurnUpdates', filter, this.config)
                          .then(response => {
                              if(response.data.ResultRows.length >= 1)
                              {
                                this.e1=4
                                this.progressBar = false
                                this.msj_proceso = "Mails Enviados exitosamente."
                                setTimeout(this.close, 3000)
                              }
                              else{
                                  this.step_error1 = true
                                  this.progressBar = false
                                  this.msj_proceso = "No se pudo enviar mail."
                              }
                          })
                          .catch(error => {
                              this.step_error1 = true
                              this.progressBar = false
                              this.msj_proceso = error.response.data.message
                          })
                      }
                      else{
                          this.step_error1 = true
                          this.progressBar = false
                          this.msj_proceso = "No se pudieron aplicar los cambios."
                      }
                  })
                  .catch(error => {
                      this.step_error1 = true
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                  })
            }
            else{
                this.step_error1 = true
                this.progressBar = false
                this.msj_proceso = "Error al guardar."
            }
          })
          .catch(error => {
            this.step_error1 = true
            this.progressBar = false
            this.msj_proceso = error.response.data.message
          })
        }, 
  
        submit(){
        this.step_txt1="Buscando Propuestas"
        this.step_txt2="Consultando"
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        this.mvm = []
        this.mvm_detail = []
        this.mvm_detail_entrega = []
        let filter = null
        
        if (this.ApiUserType == 'P'){
          if (!this.ApiUserSupplier[1]) {
            this.progressBar = false
            this.step_error1 = false
            this.msj_proceso = "No tenés un proveedor asignado. Contactá al administrador."
            return
          }
          filter = {Supplier: this.ApiUserSupplier[1]}
        }
        else{
          filter = {}
        }
        
        axios.post(this.api_tool_url + '/PreOrder_Search',filter, this.config)
            .then(response => {
  
              if(response.data.ResultRows.length >= 1)
              {
                  this.id_process = response.data.Proceso_id 
                  // console.log(response.data.ResultRows)
                  this.mvm = response.data.ResultRows
                  this.e1 = 1
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Propuestas cargadas."
                  this.active = false
                  this.progressBar = false
                  setTimeout(this.close, 3000)
              }
              else{
                  this.progressBar = false
                  this.msj_proceso = "No se encontraron turnos."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
              }
              this.btn = false
            })
            .catch(error => {
              this.mvm = []
              this.btn = false
              this.step_error1 = false
              this.progressBar = false
              this.msj_proceso = error.response.data.message
            })
        },
  
        view_detail(item){
          this.step_txt1="Buscando detalles"
          this.step_txt2="Consultando"
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          this.mvm_detail = []
          this.mvm_detail_entrega = []
          let filter = {Folio_Id : item["Supplier_id"],PreOrderPurchase_id : item["PreOrderPurchase_id"]}
          //this.currentProposalId = item["Supplier_id"]
          axios.post(this.api_tool_url + '/PreOrder_Details', filter, this.config)
                  .then(response => {
                     //console.log(response.data.ResultRows)
                      if(response.data.ResultRows.length >= 1)
                      {
                        this.mvm_detail = response.data.ResultRows
                        this.e1 = 1
                        this.step_color1 = "#008000"
                        this.msj_proceso = "Detalles cargados."
                        this.active = false
                        this.progressBar = false
                        setTimeout(this.close, 3000)
                      }
                      else{
                          this.progressBar = false
                          this.msj_proceso = "No se encontro detalle."
                          this.step_error1 = false
                          this.step_error2 = false
                          this.step_error3 = false
                      }
                  })
                  .catch(error => {
                      this.mvm_detail = []
                      this.step_error1 = false
                      this.step_error2 = false
                      this.step_error3 = false
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                  })
        },
  
        radioUpdated(e, item, value){
          const index = this.mvm_detail.indexOf(item)
          this.mvm_detail[index].RequestProposalStatus_Cd = value
        }, 
  
        checkAllRadios(value){
          this.mvm_detail = this.mvm_detail.map((detail) => ({ ...detail, RequestProposalStatus_Cd: value }))
          //console.log(this.mvm_detail)
        },
  
        onexport () { // On Click Excel download button
          // export json to Worksheet of Excel
          // const header_d_f = ['Propuesta Pedido id','OC','Punto','Fecha Turno','Fecha Cambio','Hora Cambio', 'Fecha Emisión', 'Fecha de cierre', 'Almacen', 'Bultos Pedidos', 'Pallets Pedidos', 'Indicador', 'Error', 'Error Desc', 'Estado'];
          // const header_d = ['RequestProposal_id', 'VendorPurchaseOrder_Num', 'OpPoint_id', 'OrigCDay_id', 'CDay_id', 'CHour_id', 'RequestProposal_Dt',  'Closing_Dt', 'TurningStorageArea_id', 'RequestPack_Qty', 'RequestPallet_Qty', 'Type_ind', 'ReplicationError_Cd', 'ReplicationError_Desc', 'RequestProposalStatus_Cd'];
          
          const header_d_f = ['Folio', 'Punto', 'Producto', 'Ean', 'Cant. Pedido', 'Unidad PCB', 'Fecha de Entrega', 'Hora de Entrega', 'Error', 'Error Desc']

          const header_d = ['Folio_id', 'OpPoint_id', 'Product_Description', 'ProductBarCode_id', 'Order_Qty', 'PCB_Qty', 'PreferredDelivery_Dt', 'Delivery_Tm', 'ReplicationError', 'ReplicationError_desc']
          var detalleWS = XLSX.utils.json_to_sheet(this.mvm_detail, {header: header_d}) 
  
          var range = XLSX.utils.decode_range(detalleWS['!ref']);
          for(var C = range.s.c; C <= range.e.c; ++C) {
            var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            detalleWS[colum].v = header_d_f[C];
          }
  
          range.e['c'] = header_d_f.length - 1;
          detalleWS['!ref'] = XLSX.utils.encode_range(range);
  
          // A workbook is the name given to an Excel file
          var wb = XLSX.utils.book_new() // make Workbook of Excel
  
          // add Worksheet to Workbook
          // Workbook contains one or more worksheets
          // sheetAName is name of Worksheet
          XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
          
          var file='Detalle_Modificaciones_Propuesta_'+this.currentProposalId+'.xlsx';
  
          // export Excel file
          XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
        },
  
        openDialog(items) {
          this.accept_changes = false
          if (!Array.isArray(items)) {
            items = [items]; // Convierte en array si solo se pasa un elemento
          }
          // console.log(items)
          this.dialog = true;
          this.items_edit = items.map((item) => {
            const index = this.mvm_detail.indexOf(item);
            //console.log(this.mvm_detail[index])
            return {
              PreOrderPurchase_id:  this.mvm_detail[index].PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: this.mvm_detail[index].PreOrderPurchaseDetail_id,
              folio_id: this.mvm_detail[index].Folio_id,
              ean: this.mvm_detail[index].ProductBarCode_id,
              punto: this.mvm_detail[index].OpPoint_id,
              producto: this.mvm_detail[index].Product_Description,
              pedido: this.mvm_detail[index].Order_Qty,
              cantEntregar: 0,
              fechaEntrega: this.mvm_detail[index].PreferredDelivery_Dt,
              fechaEntregaMenu: this.mvm_detail[index].PreferredDelivery_Dt,
              horaEntrega: 0,
              errorMsg: "",
              SumCantDelivery: this.mvm_detail[index].SUM_Delivery_Qty,
            };
          });
        }, 

        openDialogEditDelivery(item) {
          this.accept_changes_delivery = false
         
          //console.log(item)
          this.dialog_edit = true;
          const indice = this.mvm_detail.findIndex(det => 
          det.PreOrderPurchase_id === item.PreOrderPurchase_id 
          && det.PreOrderPurchaseDetail_id === item.PreOrderPurchaseDetail_id
          && det.Folio_id === item.Folio_id
          && det.ProductBarCode_id === item.ProductBarCode_id
          );
          //console.log(indice)
          this.items_edit =  [{
            PreOrderPurchase_id:  item.PreOrderPurchase_id,
            PreOrderPurchaseDetail_id: item.PreOrderPurchaseDetail_id,
            folio_id: item.Folio_id,
            ean: item.ProductBarCode_id,
            punto: item.OpPoint_id,
            producto: item.Product_Description,
            pedido: this.mvm_detail[indice].Order_Qty,
            cantEntregar: item.Delivery_Qty,
            fechaEntrega: this.mvm_detail[indice].PreferredDelivery_Dt,
            fechaEntregaMenu: this.mvm_detail[indice].PreferredDelivery_Dt,
            horaEntrega: 0,
            errorMsg: "",
            SumCantDelivery: (this.mvm_detail[indice].SUM_Delivery_Qty - item.Delivery_Qty),
            cantEntregarOrig: item.Delivery_Qty
          }]
          
        }, 
        
        closeDialog() {
          this.dialog = false;
          this.dialog_edit = false;
          this.currentAction = "";
          this.currentItem = null;
        },
  
        acceptChanges() {
          
          let hasError = false;
          
          this.items_edit.forEach(item => {
            item.errorMsg = ""; // Resetear mensaje de estado
  
            // Validaciones con los mensajes de error devueltos por las funciones
            let errorCantEntregar = this.validateCantEntregar(item);
            let errorFechaEntrega = this.validateFechaEntrega(item);
            let errorHoraEntrega = this.validateHoraEntrega(item);
  
            // Asignar el primer error encontrado
            if (errorCantEntregar) {
              item.errorMsg = errorCantEntregar;
              hasError = true;
            } else if (errorFechaEntrega) {
              item.errorMsg = errorFechaEntrega;
              hasError = true;
            } else if (errorHoraEntrega) {
              item.errorMsg = errorHoraEntrega;
              hasError = true;
            }
          });
  
          if (hasError) {
            return;
          }
          
          this.accept_changes = true
          this.items_edit.forEach(item => {
            item.errorMsg = "Enviando cambios...";
          });

          //console.log(this.items_edit)
  
          let promises = this.items_edit.map(item => {
            let payload = {
              PreOrderPurchase_id: item.PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: item.PreOrderPurchaseDetail_id,
              ean: item.ean,
              punto: item.punto,
              folio_id: item.folio_id,
              producto: item.producto,
              pedido: item.pedido,
              cantEntregar: item.cantEntregar,
              fechaEntrega: item.fechaEntrega,
              horaEntrega: item.horaEntrega,
              LastOpRepUser_id: sessionStorage.getItem('ApiUser_id')
            };
            return axios.post(this.api_tool_url + "/PreOrder_EditOrder", payload, this.config)
              .then(() => {
                this.mvm_detail_entrega = []
                let filter = {Folio_id : item["folio_id"],OpPoint_id : item["punto"],ProductBarCode_id : item["ean"],PreOrderPurchase_id : item["PreOrderPurchase_id"],PreOrderPurchaseDetail_id : item["PreOrderPurchaseDetail_id"]}
                //console.log(filter)
                item.errorMsg = "Cambios guardados exitosamente.";

                setTimeout(()=> {
                  this.view_detail_delivery(filter)
                }, 3500);

                setTimeout(()=> {
                  this.closeDialog()
                  this.dialog = false
                }, 3000);
              })
              .catch(error => {
                item.errorMsg = error.response.data.message || "Error al guardar los cambios.";
                throw error;
              });
          });
  
          // Promise.allSettled(promises)
          //   .then(results => {
          //     this.items_edit.forEach(item => {
          //       if (!item.errorMsg) {
          //         item.errorMsg = "Cambios guardados exitosamente.";
          //       }
          //     });
          //   });
          
          Promise.allSettled = Promise.allSettled || ((promises) => Promise.all(
            promises.map(p => p
              .then(value => {
                //console.log('Dentro de promise all settled', value)
                this.items_edit.forEach(item => {
                  if (!item.errorMsg) {
                    item.errorMsg = "Cambios guardados exitosamente. Edit";
                    setTimeout(()=> {
                      this.closeDialog()
                    }, 2000);
                  }
                });
              })
              .catch(reason => {
                item.errorMsg = "Hubo un error al guardar los cambios.";
              })
            )
          ));
        },

        acceptChangesDelivery(){
          
          let hasError = false;
          
          this.items_edit.forEach(item => {
            item.errorMsg = ""; // Resetear mensaje de estado
            
            // Validaciones con los mensajes de error devueltos por las funciones
            let errorCantEntregar = this.validateCantEntregar(item);
            let errorFechaEntrega = this.validateFechaEntregaDelivery(item);
            let errorHoraEntrega = this.validateHoraEntrega(item);
  
            // Asignar el primer error encontrado
            if (errorCantEntregar) {
              item.errorMsg = errorCantEntregar;
              hasError = true;
            } else if (errorFechaEntrega) {
              item.errorMsg = errorFechaEntrega;
              hasError = true;
            } else if (errorHoraEntrega) {
              item.errorMsg = errorHoraEntrega;
              hasError = true;
            }
          });
  
          if (hasError) {
            return;
          }
          
          this.accept_changes_delivery = true
          this.items_edit.forEach(item => {
            item.errorMsg = "Enviando cambios...";
          });

          //console.log(this.items_edit)
  
          let promises = this.items_edit.map(item => {
            let payload = {
              PreOrderPurchase_id: item.PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: item.PreOrderPurchaseDetail_id,
              ean: item.ean,
              punto: item.punto,
              folio_id: item.folio_id,
              producto: item.producto,
              pedido: item.pedido,
              cantEntregar: item.cantEntregar,
              fechaEntrega: item.fechaEntregaDelivery,
              horaEntrega: item.horaEntrega,
              LastOpRepUser_id: sessionStorage.getItem('ApiUser_id'), 
              cantEntregarOrig: item.cantEntregarOrig
            };
            return axios.post(this.api_tool_url + "/PreOrder_UpdDelivery", payload, this.config)
              .then(() => {
                this.mvm_detail_entrega = []
                let filter = {Folio_id : item["folio_id"],OpPoint_id : item["punto"],ProductBarCode_id : item["ean"],PreOrderPurchase_id : item["PreOrderPurchase_id"],PreOrderPurchaseDetail_id : item["PreOrderPurchaseDetail_id"]}
                //console.log(filter)
                
                setTimeout(()=> {
                  this.view_detail_delivery(filter)
                }, 3500);

                setTimeout(()=> {
                  this.closeDialog()
                  this.dialog_edit = false
                }, 3000);
              })
              .catch(error => {
                item.errorMsg = error.response.data.message || "Error al guardar los cambios.";
                throw error;
              });
          });
      
        },

  
        // closeDialog() {
        //   this.dialog = false;
        // },
  
        // Validar cantidad a entregar
        validateCantEntregar(item) {
          //console.log('Restante', item.pedido - item.SumCantDelivery)
          //console.log(item.SumCantDelivery)
          if (item.cantEntregar < 0) {
            return "Cant. a entregar no puede ser negativa";
          } else if (item.cantEntregar > item.pedido) {
            return "Cant. a entregar no debe ser mayor al pedido";
          }
          else if (item.cantEntregar == 0) {
            return "Cant. a entregar debe ser mayor a 0";
          } else if (item.cantEntregar > (item.pedido - item.SumCantDelivery)){
            return "Cant. no debe ser mayor al pedido + cant. editadas.";
          }
          return "";
        },
  
        // Validar fecha de entrega
        validateFechaEntrega(item) {
          const today = new Date().toISOString().split("T")[0]; // Fecha actual en formato YYYY-MM-DD
          if (item.fechaEntrega < today) {
            return "Fecha de entrega debe ser mayor o igual a hoy";
          }
          return "";
        },

        // Validar fecha de entrega
        validateFechaEntregaDelivery(item) {
          const today = new Date().toISOString().split("T")[0]; // Fecha actual en formato YYYY-MM-DD
          if (item.fechaEntregaDelivery < today) {
            return "Fecha de entrega debe ser mayor o igual a hoy";
          }
          return "";
        },
  
        // Validar hora de entrega en formato HH:MM
        validateHoraEntrega(item) {
          const regexHora = /^([01]\d|2[0-3]):([0-5]\d)$/; // Valida formato 24h (HH:MM)
          if (!regexHora.test(item.horaEntrega)) {
            return "Hora inválida, formato HH:MM";
          }
          return "";
        },
  
        view_detail_delivery(item){
          this.step_txt1="Buscando entregas"
          this.step_txt2="Consultando"
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          this.mvm_detail_entrega = []
          let filter = {Folio_Id : item["Folio_id"],OpPoint_id : item["OpPoint_id"],ProductBarCode_id : item["ProductBarCode_id"],PreOrderPurchase_id : item["PreOrderPurchase_id"],PreOrderPurchaseDetail_id : item["PreOrderPurchaseDetail_id"]}
          //this.currentProposalId = item["Supplier_id"]
          axios.post(this.api_tool_url + '/PreOrder_DetailsOrd', filter, this.config)
                  .then(response => {
                     //console.log(response.data.ResultRows)
                      if(response.data.ResultRows.length >= 1)
                      {
                        this.mvm_detail_entrega = response.data.ResultRows
                        this.e1 = 1
                        this.step_color1 = "#008000"
                        this.msj_proceso = "Detalles cargados."
                        this.active = false
                        this.progressBar = false
                        setTimeout(this.close, 3000)
                      }
                      else{
                          this.progressBar = false
                          this.msj_proceso = "No se encontro detalle."
                          this.step_error1 = false
                          this.step_error2 = false
                          this.step_error3 = false
                      }
                  })
                  .catch(error => {
                      this.mvm_detail_entrega = []
                      this.step_error1 = false
                      this.step_error2 = false
                      this.step_error3 = false
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                  })
        },

        openDialogDeleteItem (item) {
            this.dialog_delete = true
            this.deleteIndex = this.mvm_detail_entrega.indexOf(item)
            //console.log(this.deleteIndex)
            //confirm('Are you sure you want to delete this item?') && this.deleteSustitucion(index)
        },
        
        deleteRegistry() {
            this.overlay = true
            // let { VendorDivisionPartyId , LocationId , EffectiveDate, ExpirationDate} = this.items[this.deleteIndex]
            // let tpm = {
            //     VendorDivisionPartyId,
            //     LocationId,
            //     EffectiveDate, 
            //     ExpirationDate
            // }

            let tmpObj = this.mvm_detail_entrega[this.deleteIndex]
            let tpm = {
              punto: tmpObj.OpPoint_id,
              folio_id: tmpObj.Folio_id,
              ean: tmpObj.ProductBarCode_id,
              PreOrderPurchase_id: tmpObj.PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: tmpObj.PreOrderPurchaseDetail_id,
              Delivery_Qty: tmpObj.Delivery_Qty
            }
           
            axios.post(this.api_tool_url + "/PreOrder_DeleteOrder", tpm, this.config)
            .then(response => {
                //this.items.splice(this.deleteIndex, 1)
                this.mvm_detail_entrega = []
                this.close()
              })
              .catch(error => {
                  this.mvm_detail = []
                  alert(error.response.data.message)
              })
            
        },

        openDialogApproveItem (item) {
            //console.log(item)
            this.approveBtnDisabled = true
            this.dialog_approve = true
            this.approveIndex = this.mvm_detail.indexOf(item)
            // console.log(this.approveIndex)
            //confirm('Are you sure you want to delete this item?') && this.deleteSustitucion(index)
            this.progressBar = true
            this.msj_proceso = 'Recuperando datos del pedido...'
            let tmpObj = this.mvm_detail[this.approveIndex]
            //console.log(tmpObj)
            let tpm = {
              punto: tmpObj.OpPoint_id,
              folio_id: tmpObj.Folio_id,
              ean: tmpObj.ProductBarCode_id,
              PreOrderPurchase_id: tmpObj.PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: tmpObj.PreOrderPurchaseDetail_id
            }
            try{
              axios.post(this.api_tool_url + "/PreOrder_CheckQty", tpm, this.config)
              .then(response => {
                  //this.items.splice(this.deleteIndex, 1)
                  this.progressBar = false
                
                  if(response.data.resultRows[0] == 'Producto sin direccionamiento al punto'){
                    this.msj_proceso = 'Producto sin direccionamiento al punto.'
                    throw "Producto sin direccionamiento al punto."
                  }

                  this.msj_proceso = 'Datos recuperados'

                  if(response.data.resultRows[0] == 'Datos Listos para enviar'){
                    this.cantEnviada = 0
                    //console.log('Datos Listos para enviar')
                  }else if (response.data.resultRows[0] == 'Envio de pedido completo'){
                    this.cantEnviada = 0
                    this.enviarPedidoCompleto = true
                    //console.log('Envio de pedido completo')
                  }else{
                    this.cantEnviada = response.data.resultRows[1] 
                    //console.log('Cantidad Enviada', this.cantEnviada)
                  }
                  this.approveBtnDisabled = false
                  //console.log(response)
                })
              }catch(e){
                alert(e)
              }
        },
        
        approveRegistry() {
            this.dialog_approve = false
            this.dialog_apply_approve = true
            this.step_txt1="Guardando Datos"
            this.step_txt2="Enviando Mails"
            this.e1 = 1
            this.progressBar = true
            this.step_error1 = true
            this.step_error2 = true
            this.step_error3 = true
            this.step_color1 = "primary",
            this.step_color2 = "primary",
            this.step_color3 = "primary",
            this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
            this.mvm_detail_entrega = []
            
            // let { VendorDivisionPartyId , LocationId , EffectiveDate, ExpirationDate} = this.items[this.deleteIndex]
            // let tpm = {
            //     VendorDivisionPartyId,
            //     LocationId,
            //     EffectiveDate, 
            //     ExpirationDate
            // }


            let tmpObj = this.mvm_detail[this.approveIndex]
            //console.log(tmpObj)
            let tpm = {
              punto: tmpObj.OpPoint_id,
              folio_id: tmpObj.Folio_id,
              ean: tmpObj.ProductBarCode_id,
              PreOrderPurchase_id: tmpObj.PreOrderPurchase_id,
              PreOrderPurchaseDetail_id: tmpObj.PreOrderPurchaseDetail_id,
              LastOpRepUser_id: sessionStorage.getItem('ApiUser_id'),
              ApiUser_EMail: this.$store.state.ApiUser_EMail
            }

            let tomorrow = new Date();
            // add a day
            tomorrow.setDate(tomorrow.getDate() + 1);
            let dd = String(tomorrow.getDate()).padStart(2, '0');
            let mm = String(tomorrow.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = tomorrow.getFullYear();

            tomorrow = yyyy + '-' + mm  + '-' + dd;

            if(this.enviarPedidoCompleto){
              let payload = {
                PreOrderPurchase_id: tmpObj.PreOrderPurchase_id,
                PreOrderPurchaseDetail_id: tmpObj.PreOrderPurchaseDetail_id,
                ean: tmpObj.ProductBarCode_id,
                punto: tmpObj.OpPoint_id,
                folio_id: tmpObj.Folio_id,
                producto: tmpObj.Product_Description,
                pedido: tmpObj.Order_Qty,
                cantEntregar: tmpObj.Order_Qty,
                fechaEntrega: tomorrow,
                horaEntrega: '06:00',
                LastOpRepUser_id: sessionStorage.getItem('ApiUser_id')
              };
              axios.post(this.api_tool_url + "/PreOrder_EditOrder", payload, this.config)
                .then(() => {
                  // item.errorMsg = "Cambios guardados exitosamente.";
                  this.e1 = 2
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Enviando pedido completo."
                  axios.post(this.api_tool_url + "/PreOrder_ApproveOrder", tpm, this.config)
                  .then(response => {
                      //this.items.splice(this.deleteIndex, 1)
                      this.e1 = 3
                      this.step_color1 = "#008000"
                      this.msj_proceso = "Enviando mails"
                      this.active = false
                      this.progressBar = false
                      setTimeout(this.close, 3000)
                      this.submit()
                    })
                    .catch(error => {
                        alert(error.response.data.message)
                        this.progressBar = false
                        this.msj_proceso = "No se pudo aprobar."
                        this.step_error1 = false
                        this.step_error2 = false
                        this.step_error3 = false
                    })
                })
                .catch(error => {
                  // item.errorMsg = error.response.data.message || "Error al guardar los cambios.";
                  // console.log("Error al guardar los cambios.")
                  // throw error;
                  alert(error.response.data.message)
                  this.progressBar = false
                  this.msj_proceso = "No se pudo aprobar."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
                });
            }else if(this.cantEnviada != 0){
              
              let payload = {
                PreOrderPurchase_id: tmpObj.PreOrderPurchase_id,
                PreOrderPurchaseDetail_id: tmpObj.PreOrderPurchaseDetail_id,
                ean: tmpObj.ProductBarCode_id,
                punto: tmpObj.OpPoint_id,
                folio_id: tmpObj.Folio_id,
                producto: tmpObj.Product_Description,
                pedido: tmpObj.Order_Qty,
                cantEntregar: tmpObj.Order_Qty - this.cantEnviada,
                fechaEntrega: tomorrow,
                horaEntrega: '06:00',
                LastOpRepUser_id: sessionStorage.getItem('ApiUser_id')
              };
              //console.log(payload)
              //console.log('Enviando datos...')
              axios.post(this.api_tool_url + "/PreOrder_EditOrder", payload, this.config)
                .then(response => {
                  // item.errorMsg = "Cambios guardados exitosamente.";
                  this.e1 = 2
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Enviando pendientes."
                  axios.post(this.api_tool_url + "/PreOrder_ApproveOrder", tpm, this.config)
                  .then(response => {
                      //this.items.splice(this.deleteIndex, 1)
                      this.e1 = 3
                      this.step_color1 = "#008000"
                      this.msj_proceso = "Enviando mails"
                      this.active = false
                      this.progressBar = false
                      setTimeout(this.close, 3000)
                      this.submit()
                    })
                    .catch(error => {
                      alert(error.response.data.message)
                      this.progressBar = false
                      this.msj_proceso = "No se pudo aprobar."
                      this.step_error1 = false
                      this.step_error2 = false
                      this.step_error3 = false
                    })
                })
                .catch(error => {
                  // item.errorMsg = error.response.data.message || "Error al guardar los cambios.";
                  alert(error.response.data.message)
                  this.progressBar = false
                  this.msj_proceso = "No se pudo aprobar."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
                });
            }else{
              //console.log(tmpObj)
              //console.log(JSON.stringify(tpm))
              axios.post(this.api_tool_url + "/PreOrder_ApproveOrder", tpm, this.config)
              .then(response => {
                  this.e1 = 3
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Enviando mails"
                  this.active = false
                  this.progressBar = false
                  setTimeout(this.close, 3000)
                  this.submit()
                })
                .catch(error => {
                  alert(error.response.data.message)
                  this.progressBar = false
                  this.msj_proceso = "No se pudo aprobar."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
                })
            }
            
            
        },
       }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/PreOrderPurchase.vue